import { useState } from 'preact/hooks';
import { api, guardarToken, type Sesion } from '../api';

/** Datos del propio usuario y cambio de contraseña (cierra las sesiones abiertas en otros equipos). */
export function MiCuenta({ sesion }: { sesion: Sesion }) {
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [repetir, setRepetir] = useState('');
  const [msg, setMsg] = useState<{ ok: boolean; txt: string } | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function cambiar(e: Event) {
    e.preventDefault(); setMsg(null);
    if (nueva !== repetir) { setMsg({ ok: false, txt: 'La contraseña nueva y su repetición no coinciden' }); return; }
    setEnviando(true);
    try {
      const r = await api<{ token: string }>('/api/sesion/clave', { cuerpo: { actual, nueva } });
      guardarToken(r.token);
      setActual(''); setNueva(''); setRepetir('');
      setMsg({ ok: true, txt: 'Contraseña cambiada. Las sesiones abiertas en otros equipos se cerraron; en este sigues conectado.' });
    } catch (err) { setMsg({ ok: false, txt: (err as Error).message }); }
    setEnviando(false);
  }

  return (
    <div style="display:flex;flex-direction:column;gap:16px;max-width:560px">
      <div><div class="sub">Mi cuenta</div><h1>{sesion.nombre}</h1><div class="sub">{sesion.correo} · {({ administrador: 'Administrador', emisor: 'Emisor', lectura: 'Solo lectura' })[sesion.rol]}</div></div>
      <form class="tarjeta relleno" style="display:flex;flex-direction:column;gap:12px" onSubmit={cambiar}>
        <h2>Cambiar contraseña</h2>
        {sesion.sin2fa && <div class="error">Primero activa tu segundo factor.</div>}
        <div class="campo"><label for="ca">Contraseña actual</label><input id="ca" type="password" autocomplete="current-password" required value={actual} onInput={(e) => setActual((e.target as HTMLInputElement).value)} /></div>
        <div class="campo"><label for="cn">Contraseña nueva (mínimo 10 caracteres)</label><input id="cn" type="password" autocomplete="new-password" required minLength={10} value={nueva} onInput={(e) => setNueva((e.target as HTMLInputElement).value)} /></div>
        <div class="campo"><label for="cr">Repite la contraseña nueva</label><input id="cr" type="password" autocomplete="new-password" required minLength={10} value={repetir} onInput={(e) => setRepetir((e.target as HTMLInputElement).value)} /></div>
        {msg && <div class={msg.ok ? 'nota' : 'error'}>{msg.txt}</div>}
        <div class="fila" style="justify-content:flex-end"><button class="boton primario" disabled={enviando || !!sesion.sin2fa}>{enviando ? 'Guardando…' : 'Cambiar contraseña'}</button></div>
      </form>
    </div>
  );
}
